import Swiper from "swiper";
import {
  BREAKPOINT_PHONE,
  BREAKPOINT_TABLET,
  BREAKPOINT_DESKTOP,
  BREAKPOINT_DESKTOP_LG
} from "../util/constants";

export default class GenericSlider {
  constructor(elem, options = {}) {
    this.elem = $(elem);
    this.swiper = null;

    this.hasTabs = parseInt(this.elem.data("has-tabs"));

    this.loop = parseInt(this.elem.data("is-loop"));

    const slidesPerView = this.elem.data("slides-per-view");
    const spaceBetween = this.elem.data("space-between");
    const isPackages = parseInt(this.elem.data("is-packages"));
    const isHotels = parseInt(this.elem.data("is-hotels"));
    const isModern = this.elem.hasClass("generic-slider-modern-package-slider");

    const breakpoints = {};

    if (isPackages) {
      breakpoints[BREAKPOINT_PHONE] = {
        slidesPerView: 1,
        spaceBetween: 7
      };
      breakpoints[BREAKPOINT_TABLET] = {
        slidesPerView: 2,
        spaceBetween: 7
      };
      breakpoints[BREAKPOINT_DESKTOP] = {
        slidesPerView: 3,
        spaceBetween: 10
      };
    } else if (isModern) {
      breakpoints[BREAKPOINT_PHONE] = {
        slidesPerView: 1.15,
        spaceBetween: 0
      };
      breakpoints[BREAKPOINT_TABLET] = {
        slidesPerView: 2
      };
      breakpoints[BREAKPOINT_DESKTOP] = {
        slidesPerView: 3
      };
    } else {
      switch (slidesPerView) {
        case 5:
          breakpoints[BREAKPOINT_PHONE] = {
            slidesPerView: isHotels ? 1.61 : 1.5,
            spaceBetween: 10
          };
          breakpoints[BREAKPOINT_TABLET] = {
            slidesPerView: 3.1,
            spaceBetween: 7
          };
          breakpoints[BREAKPOINT_DESKTOP] = {
            slidesPerView: 3.1,
            spaceBetween: 7
          };
          breakpoints[BREAKPOINT_DESKTOP_LG] = {
            slidesPerView: 4,
            spaceBetween: 74
          };
          break;

        case 6:
          breakpoints[BREAKPOINT_PHONE] = {
            slidesPerView: 2.1,
            spaceBetween: 7
          };
          breakpoints[BREAKPOINT_TABLET] = {
            slidesPerView: 3.1,
            spaceBetween: 7
          };
          breakpoints[BREAKPOINT_DESKTOP] = {
            slidesPerView: 3.1,
            spaceBetween: 7
          };
          break;

        case 1.5:
          breakpoints[BREAKPOINT_TABLET] = {
            slidesPerView: 1.1,
            spaceBetween: 14
          };
          break;

        case 2:
          breakpoints[BREAKPOINT_TABLET] = {
            slidesPerView: 1,
            spaceBetween: 10
          };
          break;

        case 3:
          breakpoints[BREAKPOINT_PHONE] = {
            slidesPerView: 1.25,
            spaceBetween: 7
          };
          breakpoints[BREAKPOINT_TABLET] = {
            slidesPerView: 2.3,
            spaceBetween: 14
          };
          break;

        case 4:
          breakpoints[BREAKPOINT_PHONE] = {
            slidesPerView: 2.2,
            spaceBetween: 10
          };
          breakpoints[BREAKPOINT_DESKTOP] = {
            slidesPerView: 3,
            spaceBetween: 27
          };
          break;
      }
    }

    // Handle tab clicks.
    this.elem.find(".generic-slider-tabs a").click(e => {
      e.preventDefault();
      this.activateTab($(e.target).data("tab-idx"));
    });

    if (this.elem.find(".generic-slider-tabs a").length < 2) {
      this.elem.find(".generic-slider-tabs").hide();
    }

    this.elem.find("a.slide-popup").click(e => {
      e.preventDefault();
      const slide = $(e.target);
      const idx = slide.data("idx");

      const html = $(`.generic-slider-${idx} ul`).html();

      $(".sections-extra-popup")
        .find("ul.content-list")
        .html(html);
      $(".sections-extra-popup")
        .modal()
        .show();
    });

    // Initialize swiper.
    let defaultOptions = {
      slidesPerView: slidesPerView,
      spaceBetween: spaceBetween,
      breakpoints,
      navigation: {
        nextEl: this.elem.find(".swiper-button-next"),
        prevEl: this.elem.find(".swiper-button-prev")
      },
      pagination: {
        el: this.elem.find(".swiper-pagination"),
        type: "bullets"
      },

      // Disable preloading of all images.
      preloadImages: false,

      // Enable lazy loading.
      lazy: true
    };

    if (this.loop) {
      defaultOptions.loop = true;
      defaultOptions.loopAdditionalSlides = 1;
    }

    if (this.hasTabs) {
      defaultOptions.watchSlidesVisibility = true;
      defaultOptions.watchSlidesProgress = true;
    }

    $(document).ready(() => {
      const options = Object.assign(defaultOptions, options);
      this.swiper = new Swiper(this.elem.find(".swiper-container"), options);
    });

    if (document.readyState == "complete") {
      this._onWindowLoad();
    }

    $(window).on("load", this._onWindowLoad.bind(this));
  }

  _onWindowLoad() {
    setTimeout(() => {
      this.swiper.update();
      this.swiper.lazy.load();
    }, 100);

    if (this.hasTabs) {
      this.activateTab(0);
    }
  }

  activateTab(tab) {
    let tabs = this.elem.find(".generic-slider-tabs");

    const tabsItem = tabs.find("[data-tab-idx=" + tab + "]");

    // Add 'active' class to tab.
    tabs.find("a.active").removeClass("active");
    tabsItem.addClass("active");

    // Show only the active tab's slides.
    this.elem
      .find(".swiper-container .swiper-slide")
      .hide()
      .filter("[data-tab-idx=" + tab + "]")
      .show();

    // Recalculate slider.
    if (this.swiper) {
      this.swiper.update();

      this.swiper.slideTo(0);
    }
  }
}
